import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type NewsletterCtaProps = CtaShellProps

export function NewsletterCta(props: NewsletterCtaProps) {
	return <CtaShell {...props} placement={props.placement ?? "blog-inline"} layout="card" actionType="newsletter" form={props.form ?? { fields: [{ name: "email", label: "Email address", type: "email", required: true }], submitLabel: "Subscribe", successMessage: "You are subscribed." }} />
}